import { ICSSInJSStyle, pxToRem } from "@fluentui/react-northstar";

import { useFluentColorScheme } from "../../../shared/theme/useColorScheme";
import { usePlatformTypeContext } from "../../platform-type-provider/PlatformTypeProvider";

interface AudioTestEndedIssueStyles {
  container: ICSSInJSStyle;
  runTestAgain: ICSSInJSStyle;
  finishPromptHeader: ICSSInJSStyle;
  finishTestButton: ICSSInJSStyle;
  testClarityPromptButton: ICSSInJSStyle;
  description: ICSSInJSStyle;
  buttonGroup: ICSSInJSStyle;
}
export const useAudioTestEndedIssueStyles: () => AudioTestEndedIssueStyles =
  () => {
    const screenHeight = document.documentElement.clientHeight;
    const { main, brand, white } = useFluentColorScheme();
    const { isMobile } = usePlatformTypeContext();

    if (isMobile) {
      return {
        container: {
          background: main.background2,
          position: "relative",
          width: "100%",
          minHeight: screenHeight + "px",
          justifyContent: "center",
        },
        finishPromptHeader: {
          position: "static",
          color: white.foreground,
          backgroundColor: "transparent",
          maxWidth: "321px",
        },
        description: {
          position: "static",
          color: white.foreground,
          backgroundColor: "transparent",
          maxWidth: "321px",
        },
        testClarityPromptButton: {
          width: "342px",
          color: white.foreground,
          borderRadius: "8px",
          padding: pxToRem(10),
          height: "52px",
          backgroundColor: brand.background,
          border: "none",
        },
        finishTestButton: {
          width: "342px",
          color: white.foreground,
          borderRadius: "8px",
          padding: pxToRem(10),
          height: "52px",
          backgroundColor: brand.background,
          border: "none",
        },
        runTestAgain: {
          width: "342px",
          color: white.foreground,
          borderRadius: "8px",
          padding: pxToRem(10),
          height: "52px",
          backgroundColor: "transparent",
          border: `1px solid ${brand.border}`,
        },
        buttonGroup: {
          position: "absolute",
          bottom: "60px",
        },
      };
    } else {
      return {
        container: {
          width: "100%",
          height: "100%",
          backgroundColor: main.background,
          overflow: "hidden",
        },
        finishPromptHeader: {
          color: white.foreground,
          backgroundColor: "transparent",
          maxWidth: "500px",
          top: "100px",
        },
        description: {
          color: white.foreground,
          backgroundColor: "transparent",
          maxWidth: "500px",
        },
        testClarityPromptButton: {
          width: "342px",
          color: white.foreground,
          borderRadius: "8px",
          padding: pxToRem(10),
          height: "52px",
          backgroundColor: brand.background,
          border: "none",
        },
        finishTestButton: {
          width: "342px",
          color: white.foreground,
          borderRadius: "8px",
          padding: pxToRem(10),
          height: "52px",
          backgroundColor: brand.background,
          border: "none",
        },
        runTestAgain: {
          width: "342px",
          color: white.foreground,
          borderRadius: "8px",
          padding: pxToRem(10),
          height: "52px",
          backgroundColor: "transparent",
          border: `1px solid ${brand.border}`,
        },
        buttonGroup: {
          position: "absolute",
          bottom: "60px",
        },
      };
    }
  };
